"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [
    ...fragments_1.authorizationFragmentDependencies,
    fragments_1.authorizationFragment,
];
const MUTATION = `
mutation refreshAuthorization {
  refreshAuthorization {
    ...authorizationFragment
  }
}
`.trim();
const refreshAuthorizationImpl = (0, notifi_axios_utils_1.makeParameterLessRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'refreshAuthorization');
exports.default = refreshAuthorizationImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVmcmVzaEF1dGhvcml6YXRpb25JbXBsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL211dGF0aW9ucy9yZWZyZXNoQXV0aG9yaXphdGlvbkltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw0Q0FHc0I7QUFDdEIsMkVBRzRDO0FBRzVDLE1BQU0sWUFBWSxHQUFHO0lBQ25CLEdBQUcsNkNBQWlDO0lBQ3BDLGlDQUFxQjtDQUN0QixDQUFDO0FBRUYsTUFBTSxRQUFRLEdBQUc7Ozs7OztDQU1oQixDQUFDLElBQUksRUFBRSxDQUFDO0FBRVQsTUFBTSx3QkFBd0IsR0FDNUIsSUFBQSw2Q0FBd0IsRUFDdEIsSUFBQSx3Q0FBbUIsRUFBQyxHQUFHLFlBQVksRUFBRSxRQUFRLENBQUMsRUFDOUMsc0JBQXNCLENBQ3ZCLENBQUM7QUFFSixrQkFBZSx3QkFBd0IsQ0FBQyJ9